<template>
  <div class="sv sv006">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-blue" src="sv006/main.jpg">
        <p class="heading1">教えて！みんなのローン活用術</p>
        <h1 class="heading2">結婚や出産…<br />お祝いは突然やってくる?！</h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-blue _pt-sm-60"
        icon-left="sv006/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv006/avatar-b.gif"
        name-right="Bさん"
        txt-relation="会社の先輩・後輩"
      >
        会社の先輩・後輩の関係であるAさんとBさんはランチ仲間。<br />
        今日の話題は、Bさんが週末に参加した同期の結婚式のようで…。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <TalkGroup>
        <TalkBox src="sv006/avatar-a.gif"
          >週末の同期の結婚式どうだった？</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif"
          >仲良しの子だったので、感無量でした。でも、今月は大学の友達の結婚式もあって…さらに去年結婚した先輩には赤ちゃんが生まれて、お祝いラッシュでボーナスが消えてしまいそうです</TalkBox
        >
        <TalkBox src="sv006/avatar-a.gif"
          >なるほど。ご祝儀の負担が大変なのね</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif"
          >そうなんです。お祝いをケチるつもりはないんですけど、負担が大きくて</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >結婚式に必要なのは<br
          class="-pcnone"
        />ご祝儀だけじゃない！</HeadingTwo
      >

      <TalkGroup>
        <TalkBox src="sv006/avatar-a.gif"
          >ご祝儀にプラスしてドレスや美容院代もかさむものね</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif"
          >同じドレスで行くわけにもいかなくて、ドレスにヘアメイク、ネイルも含めると、それだけでお祝儀と同じくらいの金額になっちゃうこともあります</TalkBox
        >
        <TalkBox src="sv006/avatar-a.gif"
          >私も結婚ラッシュの時期は大変だったな。若手のうちは給料も心もとないから、やりくりに苦労したよ</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif"
          >お祝いごととはいえ突然やってくる出費が多くて、この先が心配になってきました…</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >資金不足でお祝いをあきらめる？</HeadingTwo
      >

      <TalkGroup src="sv006/img02.jpg">
        <TalkBox src="sv006/avatar-b.gif"
          >この先、払えなくて参加を見送るってこともあるかもしれないです</TalkBox
        >
        <TalkBox src="sv006/avatar-a.gif"
          >そうだよね。私の周りでも、お金が足りなくてご祝儀少な目にしたっていう子いたなあ</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif"
          >気持ちは分かります…ちゃんとお祝いしたいんですけどね</TalkBox
        >
        <TalkBox src="sv006/avatar-a.gif"
          >私は、ボーナスは旅行に使いたかったから、実はご祝儀が重なった時はau
          PAY スマートローンを活用してやりくりしているんだよね！</TalkBox
        >
      </TalkGroup>

      <TalkGroup class="_mb-60">
        <TalkBox src="sv006/avatar-b.gif">え？auがローン？</TalkBox>
        <TalkBox src="sv006/avatar-a.gif"
          >そうだよ。Bさんってauユーザーだったっけ？au PAY
          スマートローンは、auのローンサービスなんだよ</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif"
          >ローンってまとまった金額で借りるイメージがあります…</TalkBox
        >
        <TalkBox src="sv006/avatar-a.gif"
          >au PAY
          スマートローンは、1万円から借りられるんだよ。私は、5万円借りたかな</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >au PAY スマートローンなら、1万円から借りられる！</HeadingTwo
      >

      <ContentsCard class="-blue _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-blue" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading">
            au PAY スマートローンなら<br class="-pcnone" />こんなに便利！
          </h3>
        </div>

        <div class="card-body">
          <p class="txt01">
            ご利用限度額は、１万円~100万円（※）まで。カードレスでご利用はすべてスマートフォンで完結するのでとっても便利！
          </p>
          <ListGroup class="-note">
            <ListItem class="-note -textcenter _mb-25"
              >実際のご契約条件は、お申し込み後の審査に基づきご提示させていただきます。
            </ListItem>
          </ListGroup>

          <div class="card-groups">
            <div class="card-box">
              <div class="card-image -width90">
                <img
                  src="@/assets/images/sv/sv006/img03.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                お借り入れは1万円から！一時的にお金が足りないときに頼れる味方です。
              </div>
            </div>
            <div class="card-box">
              <div class="card-image -width80">
                <img
                  src="@/assets/images/sv/sv006/img04.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                スマートフォンがあれば、新規お申し込みもお借り入れもかんたんWEB完結！
              </div>
            </div>
            <div class="card-box">
              <div class="card-image -width80">
                <img
                  src="@/assets/images/sv/sv001/img07.gif"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                au PAY 残高にそのままチャージができます。チャージした残高は、au
                PAY プリペイドカードやau
                PAYで全国のコンビニ・スーパーやMastercard®加盟店、au
                PAY加盟店などいろいろな場所で使え、Pontaポイントもたまります。
              </div>
            </div>
          </div>
        </div>
      </ContentsCard>

      <TalkGroup class="_mb-120 _mb-sm-50">
        <TalkBox src="sv006/avatar-a.gif"
          >ご祝儀が集中する時期に利用して、分割で少しずつ返済できたから助かったよ！</TalkBox
        >
        <TalkBox src="sv006/avatar-b.gif">そんな方法もあったんですね！</TalkBox>
        <TalkBox src="sv006/avatar-a.gif"
          >借り入れ金額に応じて、毎月いくら返すのかシミュレーションもできるから一度試算してみると良いよ</TalkBox
        >
        <ListGroup class="-link _mt-30 _mb-30">
          <ListItem class="-link" router-name="sv052"
            >ご返済シミュレーションについて</ListItem
          >
        </ListGroup>
        <TalkBox src="sv006/avatar-b.gif"
          >これなら、自分のことにもボーナスを使えそうですね、さっそく調べてみます！</TalkBox
        >
        <ListGroup class="-note">
          <ListItem class="-note"
            >au PAY
            スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
          >
        </ListGroup>
      </TalkGroup>

      <div class="container _mb-md-120 _mb-sm-60">
        <BtngroupSingle>
          <BtnMain class="-normal -lg" router-name="sv002"
            >au PAY スマートローンの特徴について</BtnMain
          >
        </BtngroupSingle>
      </div>
      <CvBox class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <heading-two>おすすめ記事</heading-two>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv007" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv007/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">せっかくの卒業旅行…お金のことで諦めないで！</h3>
          </CardHeader>
          <CardBody
            >楽しいはずの旅行…お金の都合で妥協したり、諦めかけたことってありませんか？</CardBody
          >
        </CardBox>

        <CardBox router-name="sv053" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv053/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">"ちょっとだけ"がすごく助かる生活の工夫</h3>
          </CardHeader>
          <CardBody
            >ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</CardBody
          >
        </CardBox>

        <CardBox router-name="sv008" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv008/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">急な飲み会・・・給料日前だけど参加したい！</h3>
          </CardHeader>
          <CardBody
            >お誘いが多いのはうれしいけど、飲み会の回数が重なると結構な出費に…。</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";

export default {
  name: "Sv006",
  components: {
    BreadcrumbGroup,
    ContentsHeader,
    ContentsIntro,
    TalkGroup,
    TalkBox,
    HeadingTwo,
    ContentsCard,
    IconBox,
    ListGroup,
    ListItem,
    BtngroupSingle,
    BtnMain,
    CvBox,
    CardGroups,
    CardBox,
    CardHeader,
    CardImage,
    CardBody,
  },
  setup() {
    setMeta({
      title:
        "結婚や出産…お祝いは突然やってくる?！｜教えて！みんなのローン活用術",
      description:
        "みんなのローンの活用術！結婚や出産などお祝い事が続いたときに。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,結婚,出産,お祝い,一時金",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "教えて！みんなのローン活用術",
          routerName: "sv042",
        },
        {
          text: "結婚や出産…お祝いは突然やってくる?！",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

:deep(.contents-card) {
  > .card-body {
    padding-left: 20px;
    padding-right: 20px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 0px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          width: 30%;
        }
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
      }
    }
  }
}
</style>
